export const  proctorZh = {
  newShareScreenDesc1: '本场考试己开启电脑屏幕监考，请共享你的电脑屏幕',
  newShareScreenDesc2: '第一步：点击右侧的共享屏幕按钮',
  newShareScreenDesc3: '第二步：按照以下操作指引完成共享屏幕授权',
  newShareScreenDesc4: '第三步：为避免切屏，请在开始答题前稳藏共享屏幕的浮窗',
  newShareScreenDesc5: 'https://img.webloom.cn/img/newShareScreenImgZH.png',
  message1: '上传失败，请重新上传!',
  message2: '拍摄失败，请检查网络后重试!',
  uploadMessage3: '上传失败：请上传20M以内的照片!',
  uploadMessage4: '请上传jpg、jpeg或png格式的图片!',
  // 身份核验说明页
  instructions: {
    title: '身份核验说明',
    desc1: '本场考试已开启身份核验，完成核验步骤后方能进入考试。',
    desc2: '组委会将对考生身份进行人工核验。',
    desc3: '若核验未通过，组委会将保留取消考生成绩的权利与核验结果最终解释权。',
    IKnow: '我已知晓，进行身份核验'
  },
  // 拍摄照片页
  takeSelfie: {
    step1: '一、照片采集',
    step2: '二、上传证件',
    rephotograph: '重拍',
    next: '下一步',
    takeSelfie: '拍照',
    help: '没有画面?',
    cautions: '注意事项',
    Verifying: '核验中...',
    verifyAgain: '核验失败，重新核验',
    cautionsList: [
      {img: 'https://img.webloom.cn/img/right_1.png', label: '请正脸面对摄像头\n人物保持处于框内'},
      {img: 'https://img.webloom.cn/img/worng_1.png', label: '晃动模糊'},
      {img: 'https://img.webloom.cn/img/worng_2.png', label: '遮挡脸部'},
      {img: 'https://img.webloom.cn/img/worng_3.png', label: '画面多人'},
      {img: 'https://img.webloom.cn/img/worng_4.png', label: '人物出框'}
    ],
    reAccess: '重启摄像头',
    residueTimes: '剩余次数：',
    systemTipsImg: 'https://img.webloom.cn/img/IMG_8491.JPG',
    systemTips: {
      one: '1、身份核验有2次机会，请按示意图调整后进行拍照核验。',
      two: '2、若核验未通过，可上传证件照片申请人工核验后完成考试，无需等待核验结果。'
    },
    failed: '核验失败，申请人工核验',
    // 弹框
    prompt: {
      title: '人工核验说明',
      desc: '提交人工核验申请后，考生可先完成考试，组委会将对考生身份进行人工核验。若核验未通过，组委会将保留取消考生成绩的权利与核验结果最终解释权。',
      cancel: '取消',
      ok: '我已知晓'
    }
  },
  // 申请人工核验
  apply: {
    title: '申请人工核验',
    instructions: '上传证件（含照片）',
    submit: '提交',
    success: '提交成功，进入考试',
    success1: ' 核验成功，进入考试',
    successNext1: '核验成功，下一步',
    successNext: '提交成功，下一步',
    onlyTest: '仅用于本场考试'
  },
  // 监考-共享屏幕
  shareScreen: {
    MacTitle: 'Mac OS系统如何打开屏幕共享权限',
    please: '请在考试开始前',
    turnOnScreen: '打开系统屏幕录制权限',
    pleaseBefore: '',
    shareTitle: '本场考试已开启电脑屏幕监考，请共享你的电脑屏幕',
    shareTips: {
      one: '1、请在弹窗中选择整个屏幕标签，并选中所要共享的屏幕',
      two: '2、为避免切屏，请在开始答题前隐藏共享屏幕的浮窗',
      three: '3、若Mac系统无法弹出共享屏幕，请检查',
      systemShare: '系统屏幕录制权限'
    },
    shareBtn: '共享屏幕',
    hasShareBtn: '已共享电脑屏幕，等待考试开始',
    cannotShare: '当前浏览器不支持屏幕分享，请检查是否使用版本80以上的谷歌浏览器',
    shareAgain: '共享屏幕失败，请点击重试'
  },
  useComputer: '请用电脑访问www.webloom.cn进行答题'
}
export const  proctorEn = {
  newShareScreenDesc1: 'Please share your computer screen to enter the test.',
  newShareScreenDesc2: 'Step 1： Click the Share screen button on the right.',
  newShareScreenDesc3: 'Step 2： Complete the screen sharing authorization according to the following operation instructions.',
  newShareScreenDesc4: 'Step 3: To avoid the screen switching warning, please ［Hide］ the floating window before entering the test.',
  newShareScreenDesc5: 'https://img.webloom.cn/img/newShareScreenImgEN.png',
  message1: 'Upload failed. Please try again.',
  message2: 'Failed. Please try again after checking the network.',
  uploadMessage3: 'Upload failed.Please upload photo within 20m.',
  uploadMessage4: 'Please upload JPG,JPEG or PNG.',
  instructions: {
    title: 'Identity Verification Instructions',
    desc1: 'Please complete the Identity Verification in order to take the test.',
    desc2: 'We will finish the identity verification later.',
    desc3: 'If it does not pass, we reserve the right to cancel the test results and the right of final interpretation.',
    IKnow: 'Verify now'
  },
  takeSelfie: {
    step1: 'Step1 Take a selfie',
    step2: 'Step2 Upload identity documents',
    rephotograph: 'Rephotograph',
    next: 'Next',
    takeSelfie: 'Take a selfie',
    help: 'help?',
    cautions: 'Cautions',
    Verifying: 'Verifying...',
    verifyAgain: 'Failed,verify again',
    cautionsList: [
      {img: 'https://img.webloom.cn/img/right_1.png', label: 'Face the camera \n Fit your face in the middle'},
      {img: 'https://img.webloom.cn/img/worng_1.png', label: 'Shake your body'},
      {img: 'https://img.webloom.cn/img/worng_2.png', label: 'Cover your face'},
      {img: 'https://img.webloom.cn/img/worng_3.png', label: 'Multiple faces'},
      {img: 'https://img.webloom.cn/img/worng_4.png', label: 'Leave the frame'}
    ],
    reAccess: 'Re-access camera',
    residueTimes: 'Chances remaining: ',
    systemTipsImg: 'https://img.webloom.cn/img/IMG_8490.JPG',
    systemTips: {
      one: '1. Only two chances for identity verification. Please take a selfie for verification following the image.',
      two: '2. If the verification failed, you should submit a photo of identity document for manual verification. You still can take your test first without waiting for a permission.'
    },
    failed: 'Verification failed, apply for manual verification',
    prompt: {
      title: 'Manual Verification Instructions',
      desc: 'After submitting the application for manual verification, you can take the test now. We will finish the manual verification later.If it does not pass, we reserve the right to cancel the test results and the right of final interpretation.',
      cancel: 'Cancel',
      ok: 'OK'
    }
  },
  apply: {
    onlyTest: 'For this test only',
    title: 'Manual Verification Application',
    instructions: 'Upload identity documents(The photo side)',
    submit: 'Submit',
    success: 'Success,enter test',
    success1: 'Success,enter test',
    successNext1: 'Success,next',
    successNext: 'Success,next'
  },
  shareScreen: {
    MacTitle: 'Turn on screen recording permission on Mac OS',
    please: 'Please ',
    turnOnScreen: 'turn on screen recording permission ',
    pleaseBefore: 'before the test.',
    shareTitle: 'Please share your computer screen to enter the test.',
    shareTips: {
      one: '1. Select the [Entire Screen] TAB in the pop-up window and [Select] the screen you want to share',
      two: '2. To avoid the screen switching warning, please [Hide] the floating window before entering the test.',
      three: '3.If it fails on Mac, check the ',
      systemShare: 'system screen recording permission.'
    },
    shareBtn: 'Share screen',
    hasShareBtn: 'Shared, wait for the test to begin',
    cannotShare: 'The current browser does not support screen sharing, please make sure you are using Google Chrome with version 80 or higher',
    shareAgain: 'Screen sharing failed, please click to try again'
  },
  useComputer: 'Please use computer to visit www.webloom.cn'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/proctor.js